import React, { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

const languages = [
  { code: 'en', name: 'English', flag: '🇺🇸' },
  { code: 'es', name: 'Español', flag: '🇪🇸' },
  { code: 'pt', name: 'Português', flag: '🇵🇹' },
];

const normalizeLanguage = (lng) => {
  if (!lng) return 'en';
  return lng.split('-')[0].toLowerCase();
};

const LanguageSelector = () => {
  const { i18n } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  const activeLanguageCode = useMemo(() => normalizeLanguage(i18n.resolvedLanguage || i18n.language), [i18n.language, i18n.resolvedLanguage]);

  const currentLanguage =
    languages.find((lang) => lang.code === activeLanguageCode) || languages[0];

  const changeLanguage = (langCode) => {
    i18n.changeLanguage(langCode);
    setIsOpen(false);
  };

  return (
    <div className="language-selector">
      <button
        className="language-toggle"
        onClick={() => setIsOpen(!isOpen)}
        title={currentLanguage.name}
      >
        <span className="language-flag">{currentLanguage.flag}</span>
        <i className={`fa fa-chevron-down language-chevron ${isOpen ? 'open' : ''}`}></i>
      </button>

      {isOpen && (
        <>
          <div className="language-overlay" onClick={() => setIsOpen(false)}></div>
          <div className="language-menu">
            {languages.map((lang) => {
              const isActive = activeLanguageCode === lang.code;
              return (
                <button
                  key={lang.code}
                  className={`language-item ${isActive ? 'active' : ''}`}
                  onClick={() => changeLanguage(lang.code)}
                >
                  <span className="language-flag-large">{lang.flag}</span>
                  <span className="language-full-name">{lang.name}</span>
                  {isActive && <i className="fa fa-check language-check"></i>}
                </button>
              );
            })}
          </div>
        </>
      )}
    </div>
  );
};

export default LanguageSelector;
